import React from "react";
import { unescape } from "lodash";
import "./input-description.scss";

const InputDescription = ({ className = "", children }) => {
  return (
    <div
      className={`dcrform-description ${className}`}
      dangerouslySetInnerHTML={{ __html: unescape(children) }}
    ></div>
  );
};

export default InputDescription;
